import { useState } from "react";

const useOrderFiltering = (ordersList) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reviewedFilter, setReviewedFilter] = useState("all");

  const matchesSearchCriteria = (order, searchTerm) => {
    if (!searchTerm) return true;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return (
      order.ordname?.includes(searchTerm) ||
      order.custdes?.toLowerCase().includes(lowerSearchTerm) ||
      order.mcustname?.toLowerCase().includes(lowerSearchTerm) ||
      order.mcustdes?.toLowerCase().includes(lowerSearchTerm) ||
      order.endcustname?.toLowerCase().includes(lowerSearchTerm) ||
      order.ordstatusdes?.toLowerCase().includes(lowerSearchTerm) ||
      order.custname?.includes(searchTerm) ||
      order.phone?.includes(searchTerm) ||
      order.neo_ownerlogin?.includes(searchTerm) ||
      order.lines.some(
        (line) =>
          line.partname?.includes(searchTerm) ||
          line.partdes?.toLowerCase().includes(lowerSearchTerm)
      )
    );
  };

  const matchesDateRange = (order, startDate, endDate) => {
    if (!startDate && !endDate) return true;

    const orderDate = order.curdate;
    if (!orderDate) return false;

    const dateParts = orderDate.trim().split(".");
    if (dateParts.length !== 3) return false;

    const [day, month, year] = dateParts;
    const convertedDate = `${year}-${month.trim().padStart(2, "0")}-${day.trim().padStart(2, "0")}`;

    if (startDate && convertedDate < startDate) return false;
    if (endDate && convertedDate > endDate) return false;

    return true;
  };

  const matchesReviewedFilter = (order) => {
    if (reviewedFilter === "reviewed") return order.reviewed === true;
    if (reviewedFilter === "pending") return !order.reviewed;
    return true;
  };

  const filteredOrders = ordersList?.filter((order) => {
    return (
      matchesSearchCriteria(order, searchTerm) &&
      matchesDateRange(order, startDate, endDate) &&
      matchesReviewedFilter(order)
    );
  });

  return {
    searchTerm,
    setSearchTerm,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    reviewedFilter,
    setReviewedFilter,
    filteredOrders,
  };
};

export default useOrderFiltering;
